import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import { ExclamationTriangle } from './exclamation';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 0.5em;

  svg {
    width: 16px;
    height: 16px;
    fill: #d65900;
  }

  p {
    font-size: 0.75em;
    color: #585858;
    margin-left: 0.3em;
    margin-top: -0.05em;
  }
`;

const Warning = ({ text, show }) => {
  if (!show) return null;

  return (
    <Wrapper>
      <ExclamationTriangle />
      <p>{text}</p>
    </Wrapper>
  );
};

Warning.propTypes = {
  text: PropTypes.string,
  show: PropTypes.bool,
};

export default Warning;
